module.exports = {
    RECEIVE_ALL_TELECOMS: 'RECEIVE_ALL_TELECOMS',
    RECEIVE_TELECOMS_TYPES: 'RECEIVE_TELECOMS_TYPES',
    RECEIVE_TELECOM: 'RECEIVE_TELECOM',
    RECEIVE_ALL_TELECOM_SITUATIONS: 'RECEIVE_ALL_TELECOM_SITUATIONS',
    RECEIVE_TELECOMS_LAST_SITUATIONS: 'RECEIVE_TELECOMS_LAST_SITUATIONS',
    RESET_TELECOM: 'RESET_TELECOM',
    RECEIVE_TELECOM_PICTURES: 'RECEIVE_TELECOM_PICTURES',
    RECEIVE_TELECOM_FILES: 'RECEIVE_TELECOM_FILES',
    RECEIVE_TELECOM_SIM_LINK: 'RECEIVE_TELECOM_SIM_LINK',
}